const state = {
    inventoryMode: false,
    inventoryPersonal: null,
    inventoryTotal: null,

    inventoryAvailable: false,

    inventoryDrawer: false,
}

export default state
